import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface Props {
  children: ReactNode;
  display?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'hero';
  className?: string;
}

const monoSizes = {
  sm: 'text-[11px]',
  md: 'text-[14px]',
  lg: 'text-[18px]',
  xl: 'text-[28px] tracking-[-0.01em]',
  hero: 'text-[40px] tracking-[-0.02em]',
};
const displaySizes = {
  sm: 'text-[20px]',
  md: 'text-[28px]',
  lg: 'text-[40px]',
  xl: 'text-[56px]',
  hero: 'text-[72px]',
};

export function Numeric({ children, display = false, size = 'md', className }: Props) {
  if (display) {
    return (
      <span
        className={cn(
          'font-display font-normal tnum text-fg-1 leading-none',
          displaySizes[size],
          'tracking-[-0.03em]',
          className,
        )}
      >
        {children}
      </span>
    );
  }
  return (
    <span className={cn('font-mono font-medium tnum text-fg-1', monoSizes[size], className)}>
      {children}
    </span>
  );
}

export default Numeric;
